export default __webpack_public_path__ + "static/media/Punto_09_Mercato_Centrale_ENG_Def.c28eee9f.aac";